import login from "./login";
import RegisterFundSubscriber from "./registerFundSubscriber";
import registerProvider from "../registerProvider/registerProviderMain";
import varifyOTP from "./varifyOTP";
import varifyEmail from "./varifyEmail";
import resetPassword from "./resetPassword";

const auth={
     login,
     RegisterFundSubscriber,
     registerProvider,
     varifyOTP,
     varifyEmail,
     resetPassword
}
export default auth